<template>
  <div class="refund-select">
    <!-- 顶部信息卡 -->
    <div class="header-card">
      <div class="header-left">
        <div class="avatar">{{ displayNameInitial }}</div>
        <div class="user-info">
          <div class="name">{{ displayName }}</div>
        </div>
      </div>
    </div>

    <!-- 选择卡列表 -->
    <div class="title">选择要退款的就诊卡</div>
    <div class="subtitle">请根据实际情况作出选择</div>

    <div v-if="cardList.length" class="card-list">
      <template v-for="(card, idx) in cardList">
        <div class="card-item" :key="idx">
          <div class="card-left">
            <img class="icon" :src="hospitalIcon" alt="icon" />
            <div class="texts">
              <div class="amount">金额 ¥ {{ formatAmount(card.xjye00) }}</div>
              <div class="cardno">就诊卡 {{ getCardNo(card) }}</div>
            </div>
          </div>
          <van-button type="primary" round class="refund-btn" @click="goRefund(card)" :disabled="card.xjye00 <= 0">去退款</van-button>
        </div>
      </template>
    </div>
    <div v-else class="empty">暂无卡片记录</div>
  </div>
</template>

<script>
export default {
  name: "RefundSelect",
  data() {
    return {
      cardList: [],
      userName: "",
      hospitalIcon: require("@assets/icon_hospital.png")
    };
  },
  computed: {
    displayName() {
      return this.userName || "就诊人";
    },
    displayNameInitial() {
      return this.displayName ? this.displayName.substr(0, 1) : "就";
    }
  },
  created() {
    // 优先从路由参数取，取不到再从 sessionStorage 取
    const fromParams = this.$route.params && this.$route.params.cardList;
    if (Array.isArray(fromParams) && fromParams.length) {
      this.cardList = fromParams;
      sessionStorage.setItem("refundQueryCardList", JSON.stringify(fromParams));
    } else {
      try {
        const saved = sessionStorage.getItem("refundQueryCardList");
        this.cardList = saved ? JSON.parse(saved) : [];
      } catch (e) {
        this.cardList = [];
      }
    }

    // 读取用户名（来自查询页）
    const fromName = this.$route.params && this.$route.params.userName;
    if (fromName) {
      this.userName = fromName;
      try { sessionStorage.setItem("refundQueryUserName", fromName); } catch (e) {}
    } else {
      try {
        const savedName = sessionStorage.getItem("refundQueryUserName");
        this.userName = savedName || "";
      } catch (e) {
        this.userName = "";
      }
    }
  },
  methods: {
    getCardNo(card) {
      return card.cardNo || card.hisCardNo || "-";
    },
    formatAmount(val) {
      const num = typeof val === "number" ? val : parseFloat(val || 0);
      return num.toFixed(2);
    },
    goRefund(card) {
      // 跳转到退款填写页面，将选择的卡片信息透传
      const query = {
        patientName: this.userName || card.name || card.patientName || "",
        idCard: card.idCard || card.idNo || "",
        phone: card.phone || "",
        brid00: card.brid00 || "",
        hisCardNo: card.cardNo || card.hisCardNo || "",
        patientId: card.patientId || ""
      };
      this.$router.push({ name: "onlineRefundNew", query });
    }
  }
};
</script>

<style lang="less" scoped>
.refund-select {
  min-height: 100vh;
  background: #f5f7fa;
  padding: 12px;
}
.header-card {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 12px;
  border-radius: 12px;
  background: linear-gradient(135deg, #3b7cff 0%, #6a9aff 100%);
  color: #fff;
}
.header-left { display: flex; align-items: center; }
.avatar {
  width: 40px; height: 40px; border-radius: 50%;
  background: rgba(255,255,255,0.25);
  display: flex; align-items: center; justify-content: center;
  font-weight: 700; margin-right: 8px;
}
.user-info .name { font-size: 16px; font-weight: 600; }
.title { margin-top: 12px; font-size: 18px; font-weight: 600; }
.subtitle { color: #666; margin: 6px 0 12px; }

.card-list { display: flex; flex-direction: column; gap: 12px; }
.card-item { background: #fff; border-radius: 12px; padding: 12px; display: flex; justify-content: space-between; align-items: center; }
.card-left { display: flex; align-items: center; }
.icon { width: 40px; height: 40px; margin-right: 10px; }
.texts .amount { font-size: 16px; font-weight: 600; }
.texts .cardno { color: #666; margin-top: 4px; }
.refund-btn { min-width: 88px; }
</style>